if (!customElements.get('pk-facet-find')) {
  customElements.define('pk-facet-find', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      const input = this.querySelector('input');
      const list = this.nextElementSibling;
      if (!input || !list || list.tagName !== 'UL') return;
      this.bound = true;
      this.hidden = false;
      const rows = [...list.children];
      const status = this.querySelector('[role="status"]');
      input.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); event.stopPropagation(); }
      });
      input.addEventListener('input', event => {
        event.stopPropagation();
        const term = input.value.trim().toLocaleLowerCase();
        let count = 0;
        rows.forEach(row => {
          if (!term) { row.removeAttribute('data-pk-facet-match'); return; }
          const matches = row.textContent.toLocaleLowerCase().includes(term);
          const checked = !!row.querySelector('input:checked');
          row.dataset.pkFacetMatch = matches || checked ? 'yes' : 'no';
          if (matches) count++;
        });
        status.textContent = term ? (count ? `${count} matching options` : 'No matching options. Try another word.') : '';
      });
    }
  });
}
